import ResourceModel from "models/convention-api/ResourceModel"

export default class ProviderProgram extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/provider_programs"

  name!: string
}
